import { render, staticRenderFns } from "./LeaveSettingLayout.vue?vue&type=template&id=642e5d8e&scoped=true"
import script from "./LeaveSettingLayout.vue?vue&type=script&lang=js"
export * from "./LeaveSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e5d8e",
  null
  
)

export default component.exports